import React from "react";
import { AlertTriangle } from "lucide-react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message:
        error instanceof Error && error.message
          ? error.message
          : "An unexpected issue interrupted the page.",
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("AppErrorBoundary caught a render error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex min-h-screen flex-col items-center justify-center gap-6 bg-slate-950 px-6 text-center text-white"
          data-testid="app-render-error-state"
        >
          <AlertTriangle className="h-12 w-12 text-amber-500" />
          <div className="max-w-2xl space-y-3">
            <p className="eyebrow text-amber-400" data-testid="app-render-error-eyebrow">
              We&apos;re recovering safely
            </p>
            <h1 className="text-4xl font-black uppercase tracking-tight" data-testid="app-render-error-title">
              The page hit a rendering issue.
            </h1>
            <p className="body-copy text-slate-300" data-testid="app-render-error-message">
              {this.state.message}
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}